module.exports = require("file-type");


//////////////////
// WEBPACK FOOTER
// external "file-type"
// module id = 12
// module chunks = 0